(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/core/analytics/assets/javascripts/adobe-handler.js') >= 0) return;  svs.modules.push('/components/core/analytics/assets/javascripts/adobe-handler.js');
var logger = new svs.core.log.Logger('config:adobe-launch');
var senderTimeout;

function sender() {
  var notSentData = window.eddl.unsent.shift();
  if (notSentData) {
    var event = new CustomEvent('eddlChanged' + (svs.core.config.data.svsconfig.site === 'momang' ? '<mo>' : '') + notSentData.event, { detail: notSentData });
    logger.debug('dispatching event ' + notSentData.event + ' to launch');
    document.dispatchEvent(event);
    window.eddl.push(notSentData);
  }
  if (window.eddl.unsent.length > 0) {
    senderTimeout = setTimeout(sender, 0);
  } else {
    senderTimeout = undefined;
  }
}

function processDatalayer() {
  if (window.eddl && window.eddl.unsent) {
    if (!senderTimeout) {
      senderTimeout = setTimeout(sender, 10);
    }
    window.eddl.eddlPush = function(event, data) {
      var eddlData = {
        data: data,
        event: event
      };
      window.eddl.unsent.push(eddlData);
      if (!senderTimeout) {
        senderTimeout = setTimeout(sender, 10);
      }
    };
  } else {
    logger.error('analytics not loaded');
  }
}

if (window.eddl) {
  window.eddl.libraryLoaded = function(library) {
    logger.debug('library loaded ' + library);
    if (library === 'launch') {
      processDatalayer();
    }
  };
}


 })(window);